export default __webpack_public_path__ + "static/media/puzzlePieces.f84061ea.svg";